"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vueRoot = void 0;
function vueRoot(component) {
    return component.$root;
}
exports.vueRoot = vueRoot;
